import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Statuses } from './status-toggle.types';

@Component({
  selector: 'app-status-toggle',
  templateUrl: 'status-toggle.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusToggleComponent {
  @Input()
  public status: Statuses;

  @Output()
  public changeStatus: EventEmitter<Statuses.ACTIVE | Statuses.PAUSED> = new EventEmitter();

  public statuses = Statuses;
}
